export default (module, types, delimiter = '_') => {
  const namespace = {};
  Object.keys(types).forEach((type) => {
    const m = {};
    if (types[type] instanceof Object) {
      const names = Object.values(types[type]);
      names.forEach((name) => {
        m[name] = [module, type, name].join(delimiter).toUpperCase();
      });
    } else {
      m[types[type]] = [module, type, types[type]].join(delimiter).toUpperCase();
    }
    namespace[type] = m;
  });
  return namespace;
};
